
import { MutationsService } from '@vedicium/object-mutations';
import { ValidatorUtil } from '@vedicium/vue-core';
import Vue, { PropType } from 'vue';
import { APP_ERROR_EVENT } from '../../../../../constants';
import { Core } from '../../../../../services/core';

import { LightSourcePartEntity, LightSourcePartsStore } from '../../../../../services/parts';
import { PartsLightSourcesInformationForm } from '../components';

export default Vue.extend({
  name: 'partsLightSourcesViewInformation',
  props: {
    light_source: {
      type: Object as PropType<LightSourcePartEntity>,
    },
  },
  data() {
    return {
      isLoadingForm: false,

      metadata: {
        light_source: JSON.parse(JSON.stringify(this.light_source)) as LightSourcePartEntity,
      },
    };
  },
  components: {
    PartsLightSourcesInformationForm,
  },

  methods: {
    async validate() {
      await ValidatorUtil.validateArray([(this.$refs.informationForm as Vue).$v]);
    },
    async onSubmit() {
      this.$set(this, 'isLoadingForm', true);
      try {
        await this.validate();

        const mutations = MutationsService.getMutationsByComparison(
          this.light_source,
          this.metadata.light_source,
          ['description', 'type', 'power', 'ballast_power', 'x_code', 'y_code'],
        );

        if (mutations.length > 0) {
          const entity = await LightSourcePartsStore.update(
            this.light_source._meta.guid,
            mutations,
          );

          this.$emit('update:light_source', entity);
          this.$set(this.metadata, 'light_source', JSON.parse(JSON.stringify(entity)));
        }

        this.$bvToast.toast('Document successfully updated', {
          title: 'Update successful',
          variant: 'success',
          solid: true,
        });
      } catch (e) {
        Core.Eventhub.emit(APP_ERROR_EVENT, e);
        console.error(e);
        return;
      } finally {
        this.$set(this, 'isLoadingForm', false);
      }
    },
  },
});
